<template>
  <div
    class="refonte-item-file"
    v-bind:class="props.class">
    <div class="item-file-content-left">
      <div class="item-file-content-title">
        <div class="item-file-content-title-text">
          <div class="item-file-content-title-text-top">
            {{ props.title }}
          </div>
          <div
            v-if="props.subtitle"
            class="item-file-content-title-text-bottom">
            {{ props.subtitle }}
          </div>
        </div>
      </div>
    </div>
    <div class="item-file-content-middle">
      <div class="item-file-content-status">
        <div
          v-bind:class="`item-file-content-status-text ${props.pif.signee ? 'text-jinius-green' : 'text-refonte-secondary'}`">
          <div class="item-file-content-status-text-icon">
            <IconValidate20Green
              class="text-jinius-green"
              v-if="props.pif.signee" />
            <IconTime
              class="text-refonte-secondary"
              v-else />
          </div>
          <span>{{ getLabel() }}</span>
        </div>
      </div>
    </div>
    <div class="item-file-content-right">
      <template
        v-if="
          !props.pif.signee &&
          !(signatureEnCoursClient || signatureEnCoursParticipant)
        ">
        <refonte-button
          v-if="props.on_click_download"
          class="item-file-content-download"
          variant="secondary"
          v-bind:icon_left="IconDownload"
          v-on:click="props.on_click_download"
          v-tooltip="'Télécharger la version non signée'">
        </refonte-button>
        <refonte-button
          class="item-file-content-sign"
          variant="secondary"
          v-bind:icon_left="IconOpenNewTab"
          v-on:click="sign">
          Signer électroniquement
        </refonte-button>
      </template>
      <template v-else>
        <refonte-button
          v-if="props.on_click_download && props.pif.signee"
          class="item-file-content-download"
          variant="secondary"
          v-bind:icon_left="IconDownload"
          description="la version signée"
          v-tooltip="'Télécharger la version signée'"
          v-on:click="props.on_click_download">
        </refonte-button>
        <refonte-button
          variant="secondary"
          v-if="
            signatureEnCoursClient ||
            signatureEnCoursParticipant ||
            props.pif.statutSignatureId == 2
          "
          v-bind:icon_left="IconPlusCircle"
          v-on:click="openModal">
          Voir détails
        </refonte-button>
      </template>
    </div>
  </div>
  <refonte-modal-file-pif-select-signataire
    v-if="isSelectSignataireModalOpen"
    v-bind:open_signature_manuelle="openSignatureManuelle"
    header_title="Signer électroniquement votre Protocole Individuel de Formation"
    v-bind:show="isSelectSignataireModalOpen"
    v-bind:on_close="() => setIsSelectSignataireModalOpen(false)"
    v-bind:on_submit="onCloseSuccess"
    v-bind:file_title="props.title"
    v-bind:formation_title="props.pif.produitTitre || props.formation_title"
    v-bind:participant_nom_prenom="
      props.pif.participant
        ? `${props.pif.participant.nom} ${props.pif.participant.prenom}`
        : undefined
    "
    v-bind:participant="props.pif.participant"
    v-bind:session_date="props.session_date"
    v-bind:launch_url="`client/v2/${props.client_id}/pif/${props.pif.id}/signature`"
    v-bind:client_id="props.client_id" />
  <refonte-modal-file-signature-details-signed-participant
    v-bind:title="'Procotole Individuel de Formation signé'"
    v-bind:show_body="!!(props.pif.signee && props.pif?.signature)"
    v-bind:date="props.pif?.signature?.createdDate"
    v-bind:show="isDetailsSignedModalOpen"
    v-bind:on_close="() => setIsDetailsSignedModalOpen(false)" />
  <refonte-modal-file-signature-details-in-progress
    cancel_label="Annuler la procédure en cours"
    v-bind:cancel_url="`client/v2/${props.client_id}/pif/${props.pif.id}/signature`"
    v-bind:signature_maintenance="props.pif?.signatureMaintenance"
    v-bind:date="props.pif.lancement?.createdDate"
    v-bind:email="props.pif.lancement?.email"
    v-bind:show_body="!!props.pif.lancement"
    v-bind:show="isDetailsInProgressClientModalOpen"
    v-bind:client_id="props.client_id"
    v-bind:on_close="closeInProgressModal"
    v-bind:on_submit="props.on_submit" />
  <refonte-modal-file-signature-details-in-progress-participant
    v-bind:nom_prenom_participant="`${props.pif?.participant?.prenom ?? ''} ${props.pif?.participant?.nom ?? ''}`"
    v-bind:signature_maintenance="props.pif?.signatureMaintenance"
    v-bind:date="props.pif.signatureClient?.createdDate"
    v-bind:email="props.pif.signatureClient?.email"
    v-bind:nom_prenom="props.pif.signatureClient?.signataireNomPrenom"
    v-bind:show_body="!!props.pif.signatureClient"
    v-bind:show="isDetailsInProgressParticipantModalOpen"
    v-bind:on_close="closeInProgressParticipantModal" />
  <refonte-modal-file-signature-details-not-configured
    v-bind:show="isSignatureNotConfiguredModalOpen"
    v-bind:on_close="() => setIsSignatureNotConfiguredModalOpen(false)"
    v-bind:organisateur_email="props.pif?.organisateurEmail" />
  <refonte-modal-file-signature-details-maintenance
    v-bind:show="isSignatureMaintenanceModalOpen"
    v-bind:on_close="() => setIsSignatureMaintenanceModalOpen(false)" />
</template>

<script setup lang="ts">
  import IconDownload from '@/assets/img/refonte/icons/display/icon-download.svg?component';
  import IconOpenNewTab from '@/assets/img/refonte/icons/action/icon-open-new-tab.svg?component';
  import IconPlusCircle from '@/assets/img/refonte/icons/display/icon-plus-circle.svg?component';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import IconTime from '@/assets/img/refonte/icons/information/icon-time.svg?component';
  import IconValidate20Green from '@/assets/img/refonte/icons/information/icon-validate-20-green.svg?component';
  import { computed, onMounted, ref } from 'vue';
  import { PifDocument } from '@/types/gestion/inscriptions-types';
  import RefonteModalFileSignatureDetailsInProgress from '@/components/refonte/modals/refonte-modal-file-signature-details-in-progress.vue';
  import RefonteModalFileSignatureDetailsNotConfigured from '@/components/refonte/modals/refonte-modal-file-signature-details-not-configured.vue';
  import RefonteModalFileSignatureDetailsMaintenance from '@/components/refonte/modals/refonte-modal-file-signature-details-maintenance.vue';
  import RefonteModalFilePifSelectSignataire from '@/components/refonte/modals/refonte-modal-file-pif-select-signataire.vue';
  import RefonteModalFileSignatureDetailsInProgressParticipant from '@/components/refonte/modals/refonte-modal-file-signature-details-in-progress-participant.vue';
  import RefonteModalFileSignatureDetailsSignedParticipant from '@/components/refonte/modals/refonte-modal-file-signature-details-signed-participant.vue';

  const props = withDefaults(
    defineProps<{
      title: string;
      subtitle?: string;
      pif: PifDocument;
      on_click_download?: Function;
      formation_title?: string;
      session_date?: string;
      participant_nom_prenom?: string;
      client_id?: number;
      class?: string;
      on_close?: Function;
      on_submit?: Function;
      open_signature_manuelle?: Function;
    }>(),
    {
      class: ''
    }
  );
  const input = ref(null);

  onMounted(() => {
    if (input.value) {
      input.value.focus();
    }
  });
  const isDetailsSignedModalOpen = ref<boolean>(false);
  const isSignatureNotConfiguredModalOpen = ref<boolean>(false);
  const isSignatureMaintenanceModalOpen = ref<boolean>(false);
  const isDetailsInProgressClientModalOpen = ref<boolean>(false);
  const isDetailsInProgressParticipantModalOpen = ref<boolean>(false);
  const isSelectSignataireModalOpen = ref<boolean>(false);

  const signatureEnCoursClient = computed(
    () => props.pif.statutSignatureId == 1
  );

  const signatureEnCoursParticipant = computed(
    () => props.pif.statutSignatureId == 4
  );
  const getLabel = () => {
    if (props.pif.signee) {
      return 'Signé';
    }
    if (signatureEnCoursClient.value) {
      return 'En cours de signature - Cabinet';
    }

    if (signatureEnCoursParticipant.value) {
      return 'En cours de signature - Participant';
    }

    return 'En attente de signature';
  };

  const openModal = () => {
    if (signatureEnCoursClient.value) {
      setIsDetailsInProgressClientModalOpen(true);
    } else if (signatureEnCoursParticipant.value) {
      setIsDetailsInProgressParticipantModalOpen(true);
    } else if (props.pif.statutSignatureId == 2) {
      setIsDetailsSignedModalOpen(true);
    }
  };

  const setIsDetailsInProgressParticipantModalOpen = (value: boolean) => {
    isDetailsInProgressParticipantModalOpen.value = value;
  };
  const setIsDetailsSignedModalOpen = (value: boolean) => {
    isDetailsSignedModalOpen.value = value;
  };

  const closeInProgressModal = async () => {
    await setIsDetailsInProgressClientModalOpen(false);
  };

  const closeInProgressParticipantModal = async () => {
    await setIsDetailsInProgressParticipantModalOpen(false);
  };

  const onCloseSuccess = async () => {
    await setIsSelectSignataireModalOpen(false);
    if (props.on_submit) {
      props.on_submit();
    }
    if (props.on_close) {
      props.on_close();
    }
  };
  const setIsDetailsInProgressClientModalOpen = (value: boolean) => {
    isDetailsInProgressClientModalOpen.value = value;
  };

  function setIsSelectSignataireModalOpen(value: boolean) {
    isSelectSignataireModalOpen.value = value;
  }

  const setIsSignatureMaintenanceModalOpen = (value: boolean) => {
    isSignatureMaintenanceModalOpen.value = value;
  };

  const setIsSignatureNotConfiguredModalOpen = (value: boolean) => {
    isSignatureNotConfiguredModalOpen.value = value;
  };
  const openSignatureManuelle = () => {
    setIsSelectSignataireModalOpen(false);
    if (props.open_signature_manuelle) {
      props.open_signature_manuelle();
    }
  };
  const sign = () => {
    if (props.pif?.signatureNotConfigured) {
      setIsSignatureNotConfiguredModalOpen(true);
    } else if (props.pif?.signatureMaintenance) {
      setIsSignatureMaintenanceModalOpen(true);
    } else {
      setIsSelectSignataireModalOpen(true);
    }
  };
</script>

<style lang="scss" scoped>
  .refonte-item-file {
    @apply flex flex-grow bg-refonte-pale-violet-2;
    gap: 4px;
    border-radius: 8px;
    padding: 6px 12px 6px 12px;
    max-width: 700px;
    width: 100%;
    min-height: 48px;

    .item-file-content-left {
      @apply flex items-center;
      gap: 4px;
      width: 30%;

      .item-file-content-title {
        @apply flex flex-grow items-start;
        gap: 2px;

        .item-file-content-title-text {
          @apply flex flex-grow flex-col items-start;
          gap: 2px;

          .item-file-content-title-text-top {
            @apply self-stretch overflow-hidden text-ellipsis text-refonte-black;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            font-size: 13px;
            font-weight: 400;
            line-height: 16px;
          }

          .item-file-content-title-text-bottom {
            @apply self-stretch overflow-hidden text-ellipsis text-refonte-black-40;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            font-size: 12px;
            font-weight: 400;
            line-height: 14px;
          }
        }
      }
    }

    .item-file-content-middle {
      @apply flex items-center;
      width: 30%;
      gap: 4px;

      .item-file-content-status {
        @apply flex flex-grow items-center;
        gap: 4px;

        .item-file-content-status-text {
          @apply flex flex-grow items-center;
          gap: 2px;
          margin-right: 6px;

          .item-file-content-status-text-icon {
            @apply flex shrink-0 items-center justify-center;
            width: 20px;
            height: 20px;

            :deep(svg) {
              width: 18px;
              height: 18px;
            }
          }

          span {
            @apply whitespace-nowrap;
            font-size: 13px;
            line-height: 16px;
            font-weight: 400;
          }
        }
      }
    }

    .item-file-content-right {
      @apply flex justify-end;
      width: 40%;
      gap: 6px;

      .item-file-content-download {
        gap: 2px;
      }

      .item-file-content-sign {
        gap: 8px;
      }
    }

    @media (max-width: 515.98px) {
      @apply flex-col items-stretch;

      .item-file-content-left {
        max-width: 100%;

        .item-file-content-download-separator {
          @apply hidden;
        }
      }
    }
  }
</style>
